import { createFeatureSelector, ActionReducerMap } from '@ngrx/store';
import * as fromRouterReducer from './router.reducer';

import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import * as fromRouter from '@ngrx/router-store';
/**
 * storeFreeze prevents state from being mutated. When mutation occurs, an
 * exception will be thrown. This is useful during development mode to
 * ensure that none of the reducers accidentally mutates the state.
 */
import { Injectable } from '@angular/core';

export interface AppState {
  routerReducer: fromRouter.RouterReducerState<fromRouterReducer.RouterStateUrl>;
}

export const reducers: ActionReducerMap<any, any> = {
  router: fromRouter.routerReducer,
};

@Injectable()
export class CustomSerializer
  implements fromRouter.RouterStateSerializer<fromRouterReducer.RouterStateUrl>
{
  serialize(
    routerState: RouterStateSnapshot
  ): fromRouterReducer.RouterStateUrl {
    const { url } = routerState;
    const { queryParams, data } = routerState.root;
    let state: ActivatedRouteSnapshot = routerState.root;
    let params = { ...state.params };
    while (state.firstChild) {
      state = state.firstChild;
      params = { ...params, ...state.params };
    }
    return { url, queryParams, params, data };
  }
}

export const selectCoreState = createFeatureSelector<AppState>('core');
